import { log } from 'log';
import { useCallback } from 'react';

export const useRequestOobeePacket = ({
    sdk,
    serviceURL,
    oobeeURL,
    license,
    transactionID,
    userId,
    identifierType
}) => {
    return useCallback(() => {
        log('gcReq', { transactionID, license });

        sdk.configure({
            license,
            userId,
            serviceUrl: serviceURL,
            oobeeUrl: oobeeURL,
            session: transactionID,
            reason: 'bet',
            customFields: {
                transactionId: transactionID,
                // eslint-disable-next-line camelcase
                identifier_type: identifierType
            }
        });

        if (!sdk.hasGeolocatedRecently()) {
            sdk.connect({
                timeout: 15000
            }, () => {
                sdk.request();
            });
        } else {
            sdk.request();
        }
    }, [
        sdk,
        license,
        transactionID,
        userId,
        identifierType,
        serviceURL,
        oobeeURL
    ]);
};
